var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.theme }, [
    _c(
      "div",
      { staticClass: "profile" },
      [
        _c("Title", {
          attrs: { zhTitle: _vm.pageData.name, enTitle: _vm.pageData.name },
        }),
        _c("div", { staticClass: "content" }, [
          _vm.language === "zh"
            ? _c("div", {
                staticClass: "describe",
                domProps: { textContent: _vm._s(_vm.jsonData.aboutUs) },
              })
            : _vm.language === "en"
            ? _c("div", {
                staticClass: "describe",
                staticStyle: { "font-size": "14px", "overflow-y": "auto" },
                domProps: { textContent: _vm._s(_vm.jsonData.aboutUsEng) },
              })
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }